import React, { useState, useCallback, useEffect } from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Close from '@material-ui/icons/Close';
import PhoneIcon from '@material-ui/icons/Phone';
import PersonIcon from '@material-ui/icons/Person';
import { ReactComponent as ReduceButton } from '../assets/reduce.svg';
import { ReactComponent as Calendar } from '../assets/calendar.svg';
import { ReactComponent as Tools } from '../assets/tools.svg';
import Button from '../../bouton/block';
import clsx from 'clsx';
import style from '../block.module.scss';

export const MobileMenu = ({
    siteTitle,
    homeURL,
    logoURL,
    logoResponsiveURL,
    menu,
    menuRight = null,
    menuOpened,
    onClose,
    customSettings,
    showButtons = false,
    colorTempo,
}) => {
    const [extended, setExtended] = useState(true);
    const [selected, setSelected] = useState(-1);
    // TEMPO API
    const tempoDays = { BLUE: 'bleu', RED: 'rouge', WHITE: 'blanc' };
    const ejpDays = { BLUE: 'blanc', RED: 'rouge', WHITE: 'blanc' };

    const openSubCategory = (id) => {
        setSelected(id);
        setExtended(false);
    };

    const closeMenu = useCallback(() => {
        setSelected(-1);
        onClose();
        setTimeout(() => setExtended(true), 500);
    }, [onClose]);

    useEffect(() => {
        if (!menuOpened) {
            setSelected(-1);
            setTimeout(() => setExtended(true), 500);
        }
    }, [menuOpened]);

    // We transform the menu to insert the elected space
    const electedSpaceItem = customSettings.urlElectedSpaceBtn
        ? {
              children: [],
              has_children: 0,
              icon: PersonIcon,
              menu_order: 0,
              title: customSettings.textElectedSpaceBtnMobile,
              url: customSettings.urlElectedSpaceBtn,
          }
        : null;

    const arrayMenu = menu ? Object.values(menu) : null;
    if (showButtons && electedSpaceItem && arrayMenu) {
        arrayMenu.splice(0, 0, electedSpaceItem);
    }

    return (
        <>
            <div className={clsx(style.mobileMenuContainer, menuOpened && style.open)}>
                <div className={clsx(style.mainMenuCol, extended && style.extended)}>
                    <div className={style.logoContainer}>
                        <img
                            src={extended ? logoURL : logoResponsiveURL || logoURL}
                            alt={siteTitle}
                            className={clsx(style.logo, !extended && style.notExtended)}
                        />
                    </div>

                    <ul>
                        {arrayMenu &&
                            arrayMenu.map((item, index) => {
                                const hasChildren = Object.values(item.children).length > 0;
                                const Wrapper = hasChildren ? 'div' : 'a';

                                return (
                                    <Wrapper
                                        className={clsx(style.wrapper, !item.icon && style.noIcon)}
                                        href={!hasChildren ? item.url : ''}
                                        key={item.ID}
                                    >
                                        <li
                                            className={clsx(
                                                style.item,
                                                selected === index && style.selected,
                                                hasChildren && style.hasChildren,
                                                item.menu_order === 0 && style.first,
                                                !item.icon && !(showButtons && item.menu_order === 0) && style.noButton,
                                            )}
                                            onClick={() => hasChildren && openSubCategory(index)}
                                        >
                                            <div className={clsx(style.icon, item.menu_order === 0 && style.first)}>
                                                {showButtons && item.menu_order === 0 ? (
                                                    <PersonIcon />
                                                ) : item.icon ? (
                                                    <img src={item.icon} alt={''} width={14} height={14} />
                                                ) : null}
                                            </div>
                                            <p className={style.title}>{item.title}</p>
                                            <ArrowForwardIosIcon className={style.arrowRight} />
                                        </li>
                                    </Wrapper>
                                );
                            })}
                        {menuRight && Object.values(menuRight).length > 0 && (
                            <>
                                {Object.values(menuRight).map((m, index) => (
                                    <div key={`menuRight-${index}`} className={style.responsiveButtonContainer}>
                                        <Button
                                            text={extended ? m.title : ''}
                                            link={m.url}
                                            title={m.title}
                                            type={m.classes.includes('primary') ? 'primary' : 'basicOutlined'}
                                            targetBlank={m.classes.includes('account')}
                                            className={clsx(
                                                style.responsiveButton,
                                                !extended && style.notExtendedButton,
                                            )}
                                        />
                                    </div>
                                ))}
                            </>
                        )}
                        {showButtons && Object.values(showButtons).length > 0 && (
                            <>
                                {(customSettings.telephone || customSettings.urlContactBtn) && (
                                    <div className={style.responsiveButtonContainer}>
                                        <Button
                                            text={extended ? customSettings.textContactBtn : ''}
                                            startIcon={<PhoneIcon />}
                                            type={'primary'}
                                            linkType={customSettings.urlContactBtn ? 'page' : 'tel'}
                                            link={
                                                customSettings.urlContactBtn
                                                    ? customSettings.urlContactBtn
                                                    : `tel: ${customSettings.telephone}`
                                            }
                                            className={clsx(
                                                style.responsiveButton,
                                                !extended && style.notExtendedButton,
                                            )}
                                        />
                                    </div>
                                )}
                                {showButtons.toolbox && customSettings.urlTools && (
                                    <div className={style.responsiveButtonContainer}>
                                        <Button
                                            text={extended ? 'Boite à outils' : ''}
                                            startIcon={<Tools />}
                                            link={'/boite-a-outils'}
                                            linkType={'page'}
                                            type={'basicOutlined'}
                                            className={clsx(
                                                style.responsiveButton,
                                                !extended && style.notExtendedButton,
                                            )}
                                        />
                                    </div>
                                )}
                                {showButtons.calendar && customSettings.urlEvents && (
                                    <div className={style.responsiveButtonContainer}>
                                        <Button
                                            text={extended ? 'Agenda' : ''}
                                            startIcon={<Calendar />}
                                            link={'/calendrier'}
                                            linkType={'page'}
                                            type={'basicOutlined'}
                                            className={clsx(
                                                style.responsiveButton,
                                                !extended && style.notExtendedButton,
                                            )}
                                        />
                                    </div>
                                )}
                            </>
                        )}
                        {colorTempo && (
                            <>
                                <a className={clsx(!extended && style.notExtendedLink)} href="/calendrier-ejp-tempo/">
                                    <li className={style[tempoDays[colorTempo]]}>Tempo du Jour</li>
                                </a>

                                <a className={clsx(!extended && style.notExtendedLink)} href="/calendrier-ejp-tempo/">
                                    <li className={style[ejpDays[colorTempo]]}>EJP du jour</li>
                                </a>
                            </>
                        )}

                        {extended && customSettings.telElectricityRepairs && (
                            <div className={style.responsiveButtonContainer}>
                                <Button
                                    text={'Dépannage électricité'}
                                    startIcon={<PhoneIcon />}
                                    type={'primary'}
                                    linkType={'tel'}
                                    link={`tel: ${customSettings.telElectricityRepairs}`}
                                    className={clsx(style.responsiveButton, !extended && style.notExtendedButton)}
                                />
                            </div>
                        )}
                        {extended && customSettings.telEmergency && (
                            <div className={style.responsiveButtonContainer}>
                                <Button
                                    text={'Urgence gaz'}
                                    startIcon={<PhoneIcon />}
                                    type={'primary'}
                                    linkType={'tel'}
                                    link={`tel: ${customSettings.telEmergency}`}
                                    className={clsx(style.responsiveButton, !extended && style.notExtendedButton)}
                                />
                            </div>
                        )}

                        {customSettings.telCustomerService && (
                            <div className={style.responsiveButtonContainer}>
                                <Button
                                    text={'Service client'}
                                    startIcon={<PhoneIcon />}
                                    type={'primary'}
                                    linkType={'tel'}
                                    link={`tel: ${customSettings.telCustomerService}`}
                                    className={clsx(style.responsiveButton, !extended && style.notExtendedButton)}
                                />
                            </div>
                        )}
                    </ul>

                    {selected > -1 && (
                        <ReduceButton className={style.reduceButton} onClick={() => setExtended(!extended)} />
                    )}
                </div>

                <div className={clsx(style.subMenu, style.show)}>
                    <ul className={style.list}>
                        {arrayMenu &&
                            arrayMenu[selected] &&
                            Object.values(arrayMenu[selected].children).map((item) => (
                                <li className={style.item} key={item.ID}>
                                    <a href={item.url}>
                                        <div className={style.leftCol}>
                                            {item.icon && (
                                                <div className={style.icon}>
                                                    <img src={item.icon} alt={''} width={16} height={16} />
                                                </div>
                                            )}
                                            <p className={style.title}>{item.title}</p>
                                        </div>
                                        <ArrowForwardIosIcon className={style.arrowRight} />
                                    </a>
                                </li>
                            ))}
                    </ul>
                </div>
            </div>

            <div className={clsx(style.mobileMenuHead, menuOpened && style.open)}>
                {selected > -1 && (
                    <div className={style.selection}>
                        <p className={style.menu}>Menu</p>
                        <p className={style.pageTitle}>{arrayMenu[selected] && arrayMenu[selected].title}</p>
                    </div>
                )}
                <div className={style.mobileActionButtons}>
                    <Button startIcon={<Close />} type={'primary'} className={style.pictoButton} onClick={closeMenu} />
                </div>
            </div>
        </>
    );
};
